import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ImageItem } from 'src/app/ui/components/select-simple-list/model/item-image.interface';
import { statusFilter } from 'src/app/modules/news/utils/news-engagement.utils'

@Component({
  selector: 'app-news-authorization-status-filter',
  templateUrl: './news-authorization-status-filter.component.html',
  styleUrls: ['./news-authorization-status-filter.component.scss'],
})
export class NewsAuthorizationStatusFilterComponent implements OnChanges, OnInit {
  @Input() initialList: string[] = [];
  @Input() hasAuthorization: boolean = true;

  @Output() onSelectOption = new EventEmitter<string[]>();

  status: ImageItem[] = []


  readonly filterText = 'Status';
  selectAllText = 'Marcar/Desmarcar todos';
  labelText = this.filterText;
  selectedStatusName: string[] = [];
  isOpen = false;
  allSelected: boolean = false;
  hideButtons: boolean = false;


  ngOnInit(): void {
    this.status = statusFilter(this.hasAuthorization)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.status.forEach((el) => {
      el.isChecked = changes.initialList.currentValue.includes(el.id);
    });
  }

  private verifyLength(status: ImageItem[]): string {
    const countCheckedStatuses = status.filter(
      (status) => status.isChecked
    ).length;
    let statusText = '';
    if (countCheckedStatuses >= 1) {
      statusText = status.filter((status) => status.isChecked)[0].name;
      if (countCheckedStatuses > 1) {
        statusText = statusText
          .concat(' +')
          .concat((countCheckedStatuses - 1).toString());
      }
    }
    return statusText;
  }

  handleStatusSelect(status: ImageItem[]): void {
    this.isOpen = false;
    const selectedOptions = status.filter((item) => item.isChecked);
    const statusName = selectedOptions.map((item) => item.name);
    this.selectedStatusName = statusName as string[];
    const filtered = this.verifyLength(status);
    this.labelText = filtered ? filtered : this.filterText;

    this.onSelectOption.emit(this.selectedStatusName);
    this.initialList = this.selectedStatusName;
  }
}
